import { createReducer, on } from '@ngrx/store'
import { factoryLoading, ILoadingState } from '@adex/shared/models/states/loading.state'
import { setLoadingState, unauthorizedUser } from '../actions/global.actions'
import { LoadingStateCreator, patchState } from '@adex/store/utils'
import { urls } from '@adex/shared/network/urls'


const initialState: ILoadingState = LoadingStateCreator.create(urls)

export const loadingReducer = createReducer(
  initialState,
  on(unauthorizedUser, () => ({ ...initialState })),
  on(setLoadingState, (state, { url, state: loadingState, error }) =>
    patchState(state, url, factoryLoading(loadingState, state[url], error)))
)
